<template>
    <div id="printContract">
        <!--    <a @click="PrintContract" v-if="PrintBtnVisible" id="printStart">打印</a>-->
        <el-button type="primary" @click="goPrint" class="fixedButton">
            打印
        </el-button>
        <div class="printWrap">
            <div v-html="htmlContent" class="mainHtml" id="printContent"></div>
        </div>

    </div>

</template>

<script>
    import printJS from 'print-js'

    import {
        getContractDetailService //获取合同填充内容
    } from "@/services/allContractServices";

    export default {
        name: "printContract",
        data() {
            return {
                orderDetail: {},
                orderDetailList: [],
                orderbillNo: [],
                PrintBtnVisible: true, //打印按钮可见性
                htmlContent: ""
            };
        },
        created() {
            console.log(this.$route);
            // var BillNo = this.$route.query.data;
            this.htmlContent = this.$route.query.data
           
            // debugger
            // this.$refs.content.innerHTML=BillNo;
            // if (typeof BillNo === "object" && typeof BillNo != null) {
            //   this.orderbillNo = BillNo;
            // } else {
            //   this.orderbillNo.push(BillNo);
            // }
            // this.initOrderDetailTable();
        },
//   mounted() {},
        methods: {
            goPrint() {
                console.log('打印')
                printJS({
                    printable: 'printContent',
                    type: 'html',
                    //properties: [
                    //    { field: 'name', displayName: '姓名', columnSize:`50%`},
                    //    { field: 'sex', displayName: '性别',columnSize:`50%`},
                    //],
                    // header: `<p class="custom-p"> 名单 </p>`,
                    // style: '#printCons {width: 600px;} .no-print{width: 0px} .itemText1 { width: 200px } .itemText2 { width: 200px } .itemText3 { width: 200px } .itemText4 { width: 200px }',
                    // gridHeaderStyle:'font-size:12px; padding:3px; border:1px solid; font-weight: 100; text-align:left;',
                    // gridStyle:'font-size:12px; padding:3px; border:1px solid; text-align:left;',
                    // repeatTableHeader: true,
                    // scanStyles:true,
                    targetStyles: ['*'],
                    ignoreElements: ['no-print', 'bc', 'gb']
                    // printable:要打印的id。
                    // type:可以是 html 、pdf、 json 等。
                    // properties:是打印json时所需要的数据属性。
                    // gridHeaderStyle和gridStyle都是打印json时可选的样式。
                    // repeatTableHeader:在打印JSON数据时使用。设置为时false，数据表标题将仅在第一页显示。
                    // scanStyles:设置为false时，库将不处理应用于正在打印的html的样式。使用css参数时很有用。
                    // targetStyles: [’*’],这样设置继承了页面要打印元素原有的css属性。
                    // style:传入自定义样式的字符串，使用在要打印的html页面 也就是纸上的样子。
                    // ignoreElements：传入要打印的div中的子元素id，使其不打印。非常好用
                })
            },

            /**
             * 初始化全部订单表格数据,配置表格列等数据
             *
             **/
            initOrderDetailTable() {
                this.getTableData();
            },
            // getTableData() {
            //   getOrderPrintService(this.orderbillNo)
            //     .then(orderData => {
            //       this.orderDetailList = orderData;
            //       let barcodeId = "";
            //       let BillNobar = "";
            //       setTimeout(() => {
            //         for (let i = 0; i < this.orderDetailList.length; i++) {
            //           this.orderDetailList[i].goodsWeight = this.orderDetailList[
            //             i
            //           ].goodsWeight.toFixed(1);
            //           BillNobar = this.orderDetailList[i].subBillNo;
            //           barcodeId = "#barcode" + BillNobar;
            //           JsBarcode(barcodeId, BillNobar, {
            //             lineColor: "#000", //线条颜色
            //             width: 1, //线宽
            //             height: 40, //条码高度
            //             fontSize: 15, //设置文本的大小
            //             displayValue: true //是否显示文字信息
            //           });
            //         }
            //       }, 200);
            //     })
            //     .catch(error => {
            //       this.$alert(error, "错误", {
            //         confirmButtonText: "确定"
            //       });
            //     });
            // },
            barcodeId(BillNo) {
                return "barcode" + BillNo;
            },
            /**
             * 关闭当前tab页面
             */
            closePage() {
                this.bus.$emit("tabClose", "order-detail");
            },
            ClosePrintOrder() {
                this.orderbillNo = [];
                this.orderDetailList = [];
            },

            //打印当前合同
            PrintContract() {
                this.PrintBtnVisible = false;
                setTimeout(() => {
                    var newstr = document.getElementById('printContent').innerHTML
                    var oldstr = document.body.innerHTML
                    document.body.innerHTML = newstr
                    window.print();
                    document.body.innerHTML = oldstr
                    // document.body.innerHTML = oldstr;
                    setTimeout(() => {
                        this.PrintBtnVisible = true;
                        this.orderbillNo = [];
                        this.orderDetail = {};
                    }, 500);
                }, 500);
            },
        }
    };
</script>

<style>
    .printWrap {
        width: 21cm;
        margin: 30px auto;
        padding: 5mm;
        box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5);

    }

    .mainHtml {
        width: 21cm;
    }

    .fixedButton {
        position: fixed;
        top: 40%;
    }

</style>
